import { ReactNode } from 'react';

interface ButtonProps {
  onClick?: (e?: any) => void;
  children?: ReactNode;
  addClass?: string;
  submit?: boolean;
  disabled?: boolean;
}

export function AccentButton(buttonProps: ButtonProps) {
  return buttonProps?.onClick ? (
    <button
      className={
        `flex items-center justify-center bg-accent px-4 py-3.5 text-[16px] text-black disabled:cursor-not-allowed disabled:opacity-70 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  ) : (
    <button
      className={
        `flex items-center justify-center bg-accent px-4 py-3.5 text-[16px] text-black disabled:cursor-not-allowed disabled:opacity-70 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}

export function GreenGradientButton(buttonProps: ButtonProps) {
  return buttonProps?.onClick ? (
    <button
      className={
        `group relative flex h-[48px] w-auto transform items-center justify-center gap-2 rounded-[4px] bg-gradient-to-r from-[#6A9E68] to-[#5a8558] px-4 py-3 text-[16px] font-semibold text-white shadow-lg transition-all duration-300 hover:scale-[1.02] hover:shadow-xl active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 md:px-12 lg:min-w-[280px] ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  ) : (
    <button
      className={
        `group relative flex h-[48px] w-auto transform items-center justify-center gap-2 rounded-[4px] bg-gradient-to-r from-[#6A9E68] to-[#5a8558] px-4 py-3 text-[16px] font-semibold text-white shadow-lg transition-all duration-300 hover:scale-[1.02] hover:shadow-xl active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 md:px-12 lg:min-w-[280px] ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}

export function NeutralGradientButton(buttonProps: ButtonProps) {
  return buttonProps?.onClick ? (
    <button
      className={
        `group relative flex h-[48px] transform items-center justify-center gap-2 rounded-[4px] border-2 border-gray-300 bg-white px-4 py-3 text-[16px] font-semibold text-primary shadow-lg transition-all duration-300 hover:scale-[1.02] hover:border-gray-400 hover:shadow-xl active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 md:px-12 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  ) : (
    <button
      className={
        `group relative flex h-[48px] transform items-center justify-center gap-2 rounded-[4px] border-2 border-gray-300 bg-white px-4 py-3 text-[16px] font-semibold text-primary shadow-lg transition-all duration-300 hover:scale-[1.02] hover:border-gray-400 hover:shadow-xl active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 md:px-12 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}

export function AccentButtonOutline(buttonProps: ButtonProps) {
  return (
    <button
      className={
        `flex items-center justify-center border border-accent bg-white px-4 py-3.5 text-[14px] text-black hover:bg-bgyellow disabled:cursor-not-allowed disabled:opacity-70 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}

export function NeutralButton(buttonProps: ButtonProps) {
  return (
    <button
      className={
        `flex items-center justify-center border border-[#858897] bg-white px-4 py-3.5 text-[16px] text-primary disabled:cursor-not-allowed disabled:opacity-70 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}

export function PrimaryButton(buttonProps: ButtonProps) {
  return (
    <button
      className={
        `flex items-center justify-center bg-primary px-4 py-3.5 text-[16px] text-white disabled:cursor-not-allowed disabled:opacity-70 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}

export function WarningButton(buttonProps: ButtonProps) {
  return (
    <button
      className={
        `flex items-center justify-center border-[1px] border-danger bg-white px-2 py-1 text-[16px] text-black hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-70 ` +
        buttonProps?.addClass
      }
      type={buttonProps?.submit ? 'submit' : `button`}
      onClick={buttonProps?.onClick}
      disabled={buttonProps?.disabled}
    >
      {buttonProps?.children}
    </button>
  );
}
